import React from 'react';

// Forest dialog pattern for the Customers / House account screens (README
// §Phase 0.4, as in Modal.js): backdrop token, 16px radius, dialog shadow,
// 17px/600 title, 13px gray-600 body, actions right-aligned with one primary.
// Modal.js only takes a message or custom content with one confirm, so the
// form dialogs on these screens use this shell instead.

export const dialogTitleClass = 'text-[17px] font-semibold leading-6 tracking-[-0.01em] text-gray-900';
export const dialogBodyClass = 'text-[13px] text-gray-600';
export const dialogActionsClass = 'mt-6 flex flex-wrap items-center justify-end gap-2';

export const DialogShell = ({ labelledBy, onBackdrop, maxWidth = 'max-w-md', children }) => (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-[color:var(--c-backdrop)] p-4"
    onClick={onBackdrop ? (e) => { if (e.target === e.currentTarget) onBackdrop(); } : undefined}
  >
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby={labelledBy}
      className={`flex max-h-[90vh] w-full ${maxWidth} flex-col overflow-y-auto rounded-2xl border border-gray-200 bg-white p-6 shadow-lg`}
    >
      {children}
    </div>
  </div>
);

// On/off switch: floral-700 when on, gray-300 when off. The knob is on-solid
// ink (white in both Forest schemes), not bg-white, which goes dark in Forest dark.
export const Switch = ({ checked, onChange, label, disabled = false }) => (
  <button
    type="button"
    role="switch"
    aria-checked={!!checked}
    aria-label={label}
    disabled={disabled}
    onClick={() => onChange(!checked)}
    className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors duration-[120ms] disabled:cursor-not-allowed ${
      checked ? 'bg-floral-700' : 'bg-gray-300'
    }`}
  >
    <span
      className={`inline-block h-4 w-4 rounded-full bg-[rgb(var(--c-on-solid))] shadow-sm transition-transform ${checked ? 'translate-x-6' : 'translate-x-1'}`}
    />
  </button>
);
